"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialFormFieldValidation = exports.getFormFieldValidation = exports.getStagedFormFieldValidation = exports.getFormFields = exports.getCustomFormFields = exports.getFormState = exports.getStagedFormState = exports.getInitialFormState = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _get = _interopRequireDefault(require("transmute/get"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _reselect = require("reselect");

var _EmailAddress = _interopRequireDefault(require("PatternValidationJS/patterns/EmailAddress"));

var _enums = require("MeetingsBase/constants/enums");

var _utils = require("MeetingsLib/utils/utils");

function validateEmail(email) {
  if (email && _EmailAddress.default.test(email)) {
    return false;
  }

  return _I18n.default.text('prebook.details.errorHelper.email');
}

function validateFirstAndLastName(fieldValue) {
  var isValid = fieldValue !== null && fieldValue !== undefined && !(0, _utils.isWhitespace)(fieldValue) && !(0, _utils.isEmpty)(fieldValue);

  if (isValid) {
    return false;
  }

  return _I18n.default.text('prebook.details.errorHelper.required');
}

function validateCustomFormFields(customFormFields, formFields) {
  if (!formFields || !formFields.size > 0) {
    return new _immutable.Map();
  }

  var customFormFieldValidation = customFormFields.reduce(function (acc, fieldValue, fieldName) {
    var field = formFields.find(function (formField) {
      return formField.name === fieldName;
    });

    if (!field) {
      return acc.set(fieldName, false);
    }

    var hasValue = fieldValue !== null && fieldValue !== undefined;

    if (field.fieldType === _enums.FORM_FIELD_TYPES.CHECKBOX || field.fieldType === _enums.FORM_FIELD_TYPES.ENUMERATION) {
      hasValue = hasValue && fieldValue.length > 0;
    }

    if (field.type === _enums.FORM_FIELD_TYPES.TEXT) {
      hasValue = hasValue && fieldValue !== '';
    }

    if (field.fieldType === _enums.FORM_FIELD_TYPES.BOOLEAN_CHECKBOX) {
      hasValue = hasValue && fieldValue !== false;
    }

    if (!hasValue && field.isRequired) {
      return acc.set(fieldName, _I18n.default.text('prebook.details.errorHelper.required'));
    }

    return acc.set(fieldName, false);
  }, (0, _immutable.Map)());
  return customFormFieldValidation;
}

var VALIDATOR_MAP = new _immutable.Map({
  email: validateEmail,
  firstName: validateFirstAndLastName,
  lastName: validateFirstAndLastName,
  customFormFields: validateCustomFormFields
});
var getInitialFormState = (0, _get.default)('initialFormState');
exports.getInitialFormState = getInitialFormState;
var getStagedFormState = (0, _get.default)('stagedFormState');
exports.getStagedFormState = getStagedFormState;
var getFormState = (0, _get.default)('formState');
exports.getFormState = getFormState;
var getCustomFormFields = (0, _reselect.createSelector)([getStagedFormState], function (stagedFormState) {
  return stagedFormState.customFormFields;
});
exports.getCustomFormFields = getCustomFormFields;
var getFormFields = (0, _getIn.default)(['bookInfo', 'customParams', 'formFields']);
exports.getFormFields = getFormFields;

var getValidation = function getValidation(validatorMap, formStateGetter) {
  return (0, _reselect.createSelector)([formStateGetter, getFormFields], function (formState, formFields) {
    if (!formState) {
      return false;
    }

    return validatorMap.reduce(function (validationErrors, validationFunction, fieldName) {
      var formValue = formState.get(fieldName);
      return validationErrors.set(fieldName, validationFunction(formValue, formFields));
    }, new _immutable.Map());
  });
};

var getStagedFormFieldValidation = getValidation(VALIDATOR_MAP, getStagedFormState);
exports.getStagedFormFieldValidation = getStagedFormFieldValidation;
var getFormFieldValidation = getValidation(VALIDATOR_MAP, getFormState);
exports.getFormFieldValidation = getFormFieldValidation;
var getInitialFormFieldValidation = getValidation(VALIDATOR_MAP, getInitialFormState);
exports.getInitialFormFieldValidation = getInitialFormFieldValidation;